export default "__VITE_ASSET__BJ2q0zqD__"